import { render, staticRenderFns } from "./PropertyDetail.vue?vue&type=template&id=580dd06b&scoped=true"
import script from "./PropertyDetail.vue?vue&type=script&lang=js"
export * from "./PropertyDetail.vue?vue&type=script&lang=js"
import style0 from "./PropertyDetail.vue?vue&type=style&index=0&id=580dd06b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580dd06b",
  null
  
)

export default component.exports